import { createContext, useContext, useState, useCallback } from "react";
import styled, { keyframes } from "styled-components";
import theme from "./theme";

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 9999;
  pointer-events: none;
`;

const Toast = styled.div`
  background: ${(p) => p.$type === "error" ? theme.danger : p.$type === "warn" ? "#b45309" : theme.textMain};
  color: ${theme.cardBg};
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(26, 18, 8, 0.18);
  animation: ${slideIn} 0.25s ease both;
  pointer-events: auto;
  max-width: 300px;
`;

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, duration = 3000, type = "default") => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Container>
        {toasts.map((t) => (
          <Toast key={t.id} $type={t.type}>{t.message}</Toast>
        ))}
      </Container>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
